import { normalizeWatchlistLifecycle } from './watchlistLifecycle';

export const WATCHLIST_ACCEPTED_REVISION_SIGNAL_CONTRACT = (
    'accepted-watchlist-revision-signal.v1'
);
export const WATCHLIST_ACCEPTED_REVISION_SIGNAL_REFRESH_EVENT = (
    'alphamizer:watchlist-accepted-revision-signal-refresh'
);

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const SHA256_RE = /^[0-9a-f]{64}$/;

export function parseWatchlistAcceptedRevisionSignal(payload) {
    if (
        !payload
        || typeof payload !== 'object'
        || payload.success !== true
        || payload.contract !== WATCHLIST_ACCEPTED_REVISION_SIGNAL_CONTRACT
    ) {
        throw new Error('Accepted Watchlist revision signal contract is invalid.');
    }
    if (payload.current_revision == null) return null;
    const candidate = payload.current_revision;
    if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) {
        throw new Error('Accepted Watchlist revision signal is invalid.');
    }
    const revisionId = String(candidate.watchlist_revision_id || '').trim().toLowerCase();
    const revisionSeq = candidate.revision_seq;
    const stateHash = String(candidate.state_hash || '').trim().toLowerCase();
    const msiSnapshotVersion = candidate.msi_snapshot_version;
    const changeSource = String(candidate.change_source || '').trim().toLowerCase();
    const actor = String(candidate.actor || '').trim().toLowerCase();
    const appliedAt = String(candidate.applied_at || '').trim();
    if (
        !UUID_RE.test(revisionId)
        || !Number.isSafeInteger(revisionSeq)
        || revisionSeq < 1
    ) {
        throw new Error('Accepted Watchlist revision identity is incomplete.');
    }

    let publicationObservation = null;
    if (changeSource === 'msi_reconciliation') {
        if (
            !SHA256_RE.test(stateHash)
            || !Number.isSafeInteger(msiSnapshotVersion)
            || msiSnapshotVersion < 1
            || actor !== 'system'
            || !appliedAt
            || candidate.delta_classification !== 'membership_changed'
        ) {
            throw new Error('Accepted MSI reconciliation authority is invalid.');
        }
    }
    if (candidate.lifecycle != null) {
        if (candidate.delta_classification !== 'membership_changed' || !appliedAt) {
            throw new Error('Accepted Watchlist publication authority is invalid.');
        }
        const lifecycle = normalizeWatchlistLifecycle(candidate.lifecycle);
        if (
            lifecycle.status !== 'succeeded'
            || lifecycle.watchlist_revision_id !== revisionId
            || lifecycle.revision_seq !== revisionSeq
            || lifecycle.terminal_receipt?.delta_classification !== 'membership_changed'
        ) {
            throw new Error('Accepted Watchlist publication receipt is invalid.');
        }
        publicationObservation = {
            reason: changeSource === 'msi_reconciliation'
                ? 'msi_reconciliation'
                : 'accepted_revision_recovery',
            operation_type: changeSource === 'msi_reconciliation'
                ? 'watchlist_msi_reconciliation'
                : 'watchlist_accepted_revision_recovery',
            lifecycle,
        };
    }

    return {
        revisionId,
        revisionSeq,
        publicationObservation,
    };
}
